import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { User } from 'src/app/models/user.model';
import { ClientsService } from 'src/app/services/clients.service';
import { CustomerFormService } from 'src/app/services/customer-form.service';
import { QRService } from 'src/app/services/QR.service';

export interface QRData {
  scanId: string,
  clientId: string,
  clinicId: string,
  formResponseId: string,
  required: {
    name: boolean,
    surname: boolean,
    shoeSize: boolean,
    video: boolean
  },
  enableShipping: boolean,
  scanningType: string,
  referenceId: string,
  email: string,
  AIlandmarks: boolean,
}

@Component({
  selector: 'app-self-scanning-instructions',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './self-scanning-instructions.component.html',
  styleUrl: './self-scanning-instructions.component.scss'
})
export class SelfScanningInstructionsComponent {
  showFirstBox = true;
  wikyAppLink: boolean = false;
  scanId: string;
  customFormId: string
  formResponseId: string
  QRData: string
  data: QRData
  customForm
  user: User
  clientId: string
  referenceId: string
  comesFromStripe: boolean = false
  qrCode: string
  email: string
  clientHasAIlandmarks: boolean = false

  constructor(
    private route: ActivatedRoute,
    private customFormService: CustomerFormService,
    private QRService: QRService,
    private clientService: ClientsService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.scanId = params.get('scanId');
    });

    this.route.queryParams.subscribe(params => {
      this.customFormId = params['customFormId'];
      this.formResponseId = params['formResponseId']
      this.clientId = params['clientId']
      this.referenceId = params['referenceId']
      this.comesFromStripe = params['comesFromStripe'] === 'true'
      this.email = params['email']
    });

    if (window.navigator.userAgent.includes("iPhone") || window.navigator.userAgent.includes("iPad")) {
      this.wikyAppLink = true;
    }

    this.checkIfClientHasAIlandmarks()
    
  }

  getCustomForm() {
    this.customFormService.getFormById(this.customFormId).subscribe({
      next: (resp) => {
        this.customForm = resp
        this.prepareQRData()
        this.createQRcode()
        
      },
      error: (err) => {
        console.error("Error getting custom form: ", err)
      },
    })
  }

  async checkIfClientHasAIlandmarks(): Promise<void> {
    const client = await lastValueFrom(this.clientService.getClientById(this.clientId))

    if (client.AIlandmarks) {
      this.clientHasAIlandmarks = true
    }

    this.getCustomForm();
  }

  prepareQRData() {
    this.data = {
      scanId: this.scanId,
      clientId: this.clientId,
      clinicId: this.customForm.clinicId,
      formResponseId: this.formResponseId,
      required: {
        name: this.customForm.required.name,
        surname: this.customForm.required.surname,
        shoeSize: this.customForm.required.shoeSize,
        video: this.customForm.required.video
      },
      enableShipping: this.customForm.enableShipping ? this.customForm.enableShipping : false,
      scanningType: this.customForm.scanningType,
      referenceId: this.referenceId ? this.referenceId : null,
      email: this.email ? this.email : null,
      AIlandmarks: this.clientHasAIlandmarks ? this.clientHasAIlandmarks : false,
    }

    this.QRData = JSON.stringify(this.data)
    console.log("QRData: ", this.QRData)
  }

  async createQRcode() {
    const generatedCode = await lastValueFrom(this.QRService.createQR(this.data))

    this.qrCode = generatedCode.message
  }

  toggleShowFirst() {
    this.showFirstBox = !this.showFirstBox;
  }
}
